import __var_0__ from '@stdlib/stats/base/dvariancetk';
import __var_1__ from '@stdlib/math/base/special/sqrt';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var dvariancetk = __var_0__;
var sqrt = __var_1__;


// MAIN //

/**
* Computes the standard error of the mean for a double-precision floating-point strided array using a one-pass textbook algorithm.
*
* @param {PositiveInteger} N - number of indexed elements
* @param {number} correction - degrees of freedom adjustment
* @param {Float64Array} x - input array
* @param {integer} stride - stride length
* @returns {number} standard error of the mean
*
* @example
* var Float64Array = require( '@stdlib/array/float64' );
*
* var x = new Float64Array( [ 1.0, -2.0, 2.0 ] );
* var N = x.length;
*
* var v = dsemtk( N, 1, x, 1 );
* // returns ~1.20185
*/
function dsemtk( N, correction, x, stride ) {
	return sqrt( dvariancetk( N, correction, x, stride ) / N );
}


// EXPORTS //
export default dsemtk;
